export const getInterestPreviewById = (state: State) =>
  state.interestPreview.byId;

export const getIsFetchingInterestPreview = (state: State) =>
  state.interestPreview.isFetching;

export const getIsCreatingInterestCharges = (state: State) =>
  Boolean(state.interestPreview.isCreating);
